export default class TextFormatter {
    config;
    constructor($config) {
        this.config = $config;
    }
    execConvert($text) {
        let text = $text;
        const filteredSetting = Object.fromEntries(
        // Object.entries(this.config).filter(([key, value]) => value != null && value != 0)
        Object.entries(this.config).filter(([key, value]) => value != null && value != 0));
        Object.keys(filteredSetting).forEach((key) => {
            switch (key) {
                case 'remove_fullwidth_space':
                    if (Array.isArray(this.config[key])) {
                        const config = this.config[key];
                        config.forEach((value) => {
                            if (value == 1) {
                                text = this.removeFullWidthSpace(text);
                            }
                            else if (value == 2) {
                                text = this.removeHalfWidthSpace(text);
                            }
                        });
                    }
                    else {
                        text = this.config[key] == 1 ? this.removeFullWidthSpace(text) : this.removeHalfWidthSpace(text);
                    }
                    break;
                case 'replace_alpha_numeric':
                    text = this.config[key] == 1 ? this.toFullWidthAlphanumeric(text) : (this.config[key] == 2 ? this.convertFullWidthAlphanumeric(text) : this.convertMixedWidthCharacters(text));
                    break;
                case 'replace_brackets':
                    text = this.config[key] == 1 ? this.toFullWidthParentheses(text) : this.toHalfWidthParentheses(text);
                    break;
                case 'replace_kana':
                    text = this.config[key] == 1 ? this.toKanaZenkaku(text) : this.toFullToHalfKana(text);
                    break;
                case 'replace_punctuation':
                    text = this.config[key] == 1 ? this.toFullWidthPunctuation(text) : this.toHalfWidthPunctuation(text);
                    break;
            }
        });
        return text;
    }
    //全角英数字を半角に変換　
    convertFullWidthAlphanumeric(str) {
        return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
    }
    // 全角英数字を半角に変換　単独で存在する一桁の半角数字や英字を全角に変換
    convertMixedWidthCharacters(str) {
        str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        return str.replace(/(?<!\d)[0-9](?!\d)|(?<![A-Za-z])[A-Za-z](?![A-Za-z])/g, (s) => {
            return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
        });
    }
    // 半角英数字を全角に変換
    toFullWidthAlphanumeric(str) {
        return str.replace(/[A-Za-z0-9]/g, (s) => {
            return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
        });
    }
    toKanaZenkaku(str) {
        // lengthの等しい2つの文字列でkey-valueをつくる
        const makeMap = (str1, str2) => str1
            .split("")
            .reduce((acc, char, i) => ({ ...acc, [char]: str2[i] }), {});
        const HAN_DAKUTEN = "ﾞ";
        const HAN_HANDAKUTEN = "ﾟ";
        // 半角-全角対応表
        const plainHanZenMap = makeMap("ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜｦﾝｧｨｩｪｫｯｬｭｮｰ", "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンァィゥェォッャュョー");
        // 全角での清音-濁音半濁音対応表
        const dakuMaps = {
            [HAN_DAKUTEN]: makeMap("ウカキクケコサシスセソタチツテトハヒフヘホ", "ヴガギグゲゴザジズゼゾダヂヅデドバビブベボ"),
            [HAN_HANDAKUTEN]: makeMap("ハヒフヘホ", "パピプペポ")
        };
        return str.split("").reduce((current, char) => {
            if (plainHanZenMap[char]) {
                return current + plainHanZenMap[char];
            }
            if (char === HAN_DAKUTEN || char === HAN_HANDAKUTEN) {
                const lastChar = current.charAt(current.length - 1);
                return (current.slice(0, -1) + (dakuMaps[char][lastChar] || lastChar + char));
            }
            return current + char;
        }, "");
    }
    toFullToHalfKana(str) {
        const fullToHankakuMap = {
            "ガ": "ｶﾞ", "ギ": "ｷﾞ", "グ": "ｸﾞ", "ゲ": "ｹﾞ", "ゴ": "ｺﾞ",
            "ザ": "ｻﾞ", "ジ": "ｼﾞ", "ズ": "ｽﾞ", "ゼ": "ｾﾞ", "ゾ": "ｿﾞ",
            "ダ": "ﾀﾞ", "ヂ": "ﾁﾞ", "ヅ": "ﾂﾞ", "デ": "ﾃﾞ", "ド": "ﾄﾞ",
            "バ": "ﾊﾞ", "ビ": "ﾋﾞ", "ブ": "ﾌﾞ", "ベ": "ﾍﾞ", "ボ": "ﾎﾞ",
            "パ": "ﾊﾟ", "ピ": "ﾋﾟ", "プ": "ﾌﾟ", "ペ": "ﾍﾟ", "ポ": "ﾎﾟ",
            "ヴ": "ｳﾞ", "ヷ": "ﾜﾞ", "ヺ": "ｦﾞ",
            "ア": "ｱ", "イ": "ｲ", "ウ": "ｳ", "エ": "ｴ", "オ": "ｵ",
            "カ": "ｶ", "キ": "ｷ", "ク": "ｸ", "ケ": "ｹ", "コ": "ｺ",
            "サ": "ｻ", "シ": "ｼ", "ス": "ｽ", "セ": "ｾ", "ソ": "ｿ",
            "タ": "ﾀ", "チ": "ﾁ", "ツ": "ﾂ", "テ": "ﾃ", "ト": "ﾄ",
            "ナ": "ﾅ", "ニ": "ﾆ", "ヌ": "ﾇ", "ネ": "ﾈ", "ノ": "ﾉ",
            "ハ": "ﾊ", "ヒ": "ﾋ", "フ": "ﾌ", "ヘ": "ﾍ", "ホ": "ﾎ",
            "マ": "ﾏ", "ミ": "ﾐ", "ム": "ﾑ", "メ": "ﾒ", "モ": "ﾓ",
            "ヤ": "ﾔ", "ユ": "ﾕ", "ヨ": "ﾖ",
            "ラ": "ﾗ", "リ": "ﾘ", "ル": "ﾙ", "レ": "ﾚ", "ロ": "ﾛ",
            "ワ": "ﾜ", "ヲ": "ｦ", "ン": "ﾝ",
            "ァ": "ｧ", "ィ": "ｨ", "ゥ": "ｩ", "ェ": "ｪ", "ォ": "ｫ",
            "ッ": "ｯ", "ャ": "ｬ", "ュ": "ｭ", "ョ": "ｮ",
            "ー": "-"
        };
        return str.split('').map(char => fullToHankakuMap[char] || char).join('');
    }
    //全角スペースを削除
    removeFullWidthSpace = (str) => {
        return str.replace(/　/g, '');
    };
    //半角スペース,ノーブレークスペース(&nbsp;)を削除
    removeHalfWidthSpace = (str) => {
        return str.replace(/[ \u00A0]/g, '');
    };
    //半角括弧を全角括弧に変換　    {([])}　→　｛（［］）｝
    toFullWidthParentheses = (str) => {
        return str.replace(/[\(\)\[\]\{\}]/g, (s) => {
            return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
        });
    };
    // 全角の括弧を半角に変換
    toHalfWidthParentheses = (str) => {
        return str.replace(/[（）［］｛｝]/g, (s) => {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
    };
    toFullWidthPunctuation(str) {
        return str.replace(/[\uff0c\uff0e]/g, (s) => {
            return s === '，' ? '、' : '。';
        });
    }
    // 句読点を半角に統一
    toHalfWidthPunctuation(str) {
        return str.replace(/[、。]/g, (s) => {
            return s === '、' ? '，' : '．';
        });
    }
}
